import React from "react";
import "./App.css";
import AppRoutes from "./routes";
import "./styles/main.scss";

const App = () => {
    return <AppRoutes />;
};

export default App;
